import React, { Component } from 'react'
import { Form, Alert } from 'react-bootstrap'
import MediaQuery from 'react-responsive'
import { withTranslation } from 'react-i18next'
import { observable, makeObservable } from 'mobx'
import { inject, observer } from 'mobx-react'
import styled, { withTheme } from 'styled-components'

import { formatedPriceObject } from '../../../utils/formatedPrice'
import PlusMinusAmount from '../../Forms/PlusMinusAmount'
import { OverlayLoadingLayer } from '../../Loading/OverlayLoadingLayer'
import { colors } from '../../../styles/colors'
import {
    CategoryIconDefault,
    CategoryIcons,
} from '../../Icons/CategoryIcons/CategoryIcons'
import VariantSelector from './VariantSelector'

const StyledAccessoryItemWrapper = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 85px 1fr auto;
  border-bottom: 1px solid ${colors.gray1};

  @media screen and (min-width: 992px) {
    grid-template-columns: 85px 1fr 140px 115px 100px;
    align-items: center;
  }
  @media (max-width: 567px) {
    display: flex !important;
    flex-direction: column !important;
    grid-template-columns: none !important;
  }
`

const StyledProdcutHeader = styled.div`
  opacity: 0.5;
`

const StyledImgCol = styled.div`
  align-self: center;
  grid-row: span 2;

  @media screen and (min-width: 992px) {
    grid-row: auto;
  }
  @media (max-width: 567px) {
    margin-bottom: 10px;
  }
`

const StyledProductImgWrap = styled.div`
  width: 85px;
  height: 85px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
  }
`

const StyledProductImg = styled.img`
  max-width: 100%;
  max-height: 100%;
`

const StyledProductDescriptionCol = styled.div`
  padding-left: 20px;
  padding-right: 20px;
  grid-column: span 2;
  @media screen and (min-width: 430px) {
    grid-column: auto;
  }
  @media (max-width: 567px) {
    font-size: 0.9rem;
    padding: 0;
  }
`

const StyledProductSubDescription = styled.div`
  color: ${colors.gray3};
  font-weight: 600;
  @media (max-width: 567px) {
    font-size: 0.9rem;
  }
`

const StyledPriceCol = styled.div`
  align-self: end;
  grid-row: 2;
  grid-column: 3;
  text-align: right;
  white-space: nowrap;

  @media screen and (min-width: 430px) {
    grid-row: 1;
  }
  @media screen and (min-width: 992px) {
    align-self: auto;
    grid-row: auto;
    grid-column: auto;
    padding: 20px;
  }
  @media (max-width: 567px) {
    margin: 10px 0px;
  }
`

const StyledVariantCol = styled.div`
  grid-column: 3;
  text-align: center;
  white-space: nowrap;

  @media screen and (min-width: 992px) {
    grid-column: auto;
    padding: 20px 0 20px 20px;
  }
`
const StyledAmountLabel = styled(Form.Label)`
  @media screen and (max-width: 991px) {
    padding: 12px 16px;
    display: inline-block;
  }
  @media (max-width: 567px) {
    font-size: 0.9rem;
    padding: 12px 0px;
    margin-bottom: 0 !important;
  }
`
const StyledAmountGroup = styled(Form.Group)`
  padding: 0 20px;

  @media (max-width: 567px) {
    display: flex;
    font-size: 0.9rem;
    justify-content: space-between;
    padding: 0;
    input {
      font-size: 1rem !important;
      height: 32px !important;
      padding: 4px 6px !important;
    }

    button {
      font-size: 1rem !important;
      padding: 4px 10px !important;
      height: 32px !important;
    }
  }
`
const StyledMainArticleAmount = styled.div`
  color: ${colors.gray3};
  font-weight: 600;
  text-align: center;
`

class AccessoryItem extends Component {
    quantity = 0
    isLoading = false
    constructor(props) {
        super(props)

        makeObservable(this, {
            quantity: observable,
            isLoading: observable,
        })

        this.quantity = props.position.quantity
    }

    onClickPlusIcon = async (e) => {
        const { article } = this.props
        e.preventDefault()
        this.quantity += article.article.packageSize
            ? article.article.packageSize
            : 1

        this.changeQuantityInBasket(this.quantity)
    }

    onClickMinusIcon = async (e) => {
        const { article } = this.props
        e.preventDefault()
        this.quantity -= article.article.packageSize
            ? article.article.packageSize
            : 1

        this.changeQuantityInBasket(this.quantity)
    }
    onChangeQauantity = async (e) => {
        const { value } = e.target

        if (parseInt(value)) {
            this.quantity = parseInt(value)
            this.changeQuantityInBasket(this.quantity)
        }
    }
    changeQuantityInBasket = async (quantity) => {
        const { article, handleChangePositionQuantity } = this.props
        handleChangePositionQuantity(article.id, quantity)
    }
    changeVariantInBasket = async (variant) => {
        const { article, handleChangePositionVariant } = this.props
        handleChangePositionVariant(article.id, variant)
    }
    getProductHeadline = () => {
        const { article } = this.props
        let chunks = []
        if (
            article.contingentAvailability &&
            article.contingentAvailability.displayName
        ) {
            chunks.push(article.contingentAvailability.displayName)
        }
        if (
            article.categoryAvailability &&
            article.categoryAvailability.displayName
        ) {
            chunks.push(article.categoryAvailability.displayName)
        }
        return chunks.join(' / ')
    }

    getSubDescription = (position) => {
        let subDescriptionParts = []
        if (position.comment) {
            subDescriptionParts.push(position.comment)
        }
        return subDescriptionParts.length ? subDescriptionParts.join(' | ') : ''
    }

    render() {
        const {
            t,
            productsStore,
            theme,
            article,
            position,
            isMainArticle,
            formErrors
        } = this.props
        const CategoryIcon =
            this.props.iconType && CategoryIcons[this.props.iconType]
                ? CategoryIcons[this.props.iconType]
                : CategoryIconDefault

        const productHeadline = this.getProductHeadline()
        const subDescription = this.getSubDescription(position)

        let sumPriceObject, sumPrice, sumShortPrice

        if (position.pricePerItem !== null) {
            sumPriceObject = {
                price:
                    position.pricePerItem.price === null
                        ? null
                        : position.pricePerItem.price * position.quantity,
                currency: position.pricePerItem.currency,
                points:
                    position.pricePerItem.points === null
                        ? null
                        : position.pricePerItem.points * position.quantity,
            }
            sumPrice = formatedPriceObject(sumPriceObject)
            sumShortPrice = formatedPriceObject(sumPriceObject, true)
        }

        return (
            <React.Fragment>
                <StyledAccessoryItemWrapper
                    className={this.isLoading ? 'is-loading' : ''}
                >
                    <StyledImgCol>
                        <StyledProductImgWrap>
                            {article.article.image && article.article.image.url ? (
                                <StyledProductImg src={article.article.image.url} alt='' />
                            ) : (
                                <CategoryIcon color={theme.primaryColor} />
                            )}
                        </StyledProductImgWrap>
                    </StyledImgCol>
                    <StyledProductDescriptionCol>
                        <StyledProdcutHeader className='text-primary'>
                            <i>
                                <small>{productHeadline}</small>
                            </i>
                        </StyledProdcutHeader>
                        <span>{article.article.displayName}</span>
                        <StyledProductSubDescription>
                            {subDescription}
                        </StyledProductSubDescription>
                    </StyledProductDescriptionCol>
                    <StyledVariantCol>
                        {!article.article.isWithSizes ? null
                            :
                            <>
                                <StyledAmountLabel>{t('productDetail:size')}</StyledAmountLabel>
                                <VariantSelector
                                    articleId={article.article.id}
                                    selectedVariant={position.articleVariant}
                                    disabled={isMainArticle}
                                    handleOnChange={this.changeVariantInBasket}
                                />
                            </>
                        }
                    </StyledVariantCol>
                    <StyledAmountGroup>
                        <StyledAmountLabel>{t('amount')}</StyledAmountLabel>
                        {isMainArticle ?
                            <StyledMainArticleAmount>{this.quantity}</StyledMainArticleAmount>
                            :
                            <PlusMinusAmount
                                placeholder='1'
                                value={this.quantity}
                                onChange={this.onChangeQauantity}
                                onChangePlus={this.onClickPlusIcon}
                                onChangeMinus={this.onClickMinusIcon}
                                disableMinus={
                                    this.quantity === 0 || this.quantity <= article.article.minimumQuantity || isMainArticle
                                }
                                disablePlus={
                                    (article.article.maximumQuantity && this.quantity >= article.article.maximumQuantity) || isMainArticle
                                }
                                disableField={isMainArticle}
                            />
                        }
                    </StyledAmountGroup>
                    <StyledPriceCol>
                        {!productsStore.hidePricesAndPoints && position.pricePerItem !== null ? (
                            <>
                                <MediaQuery maxWidth={991}>{sumShortPrice}</MediaQuery>
                                <MediaQuery minWidth={992}>{sumPrice}</MediaQuery>
                            </>
                        ) : (
                            ''
                        )}
                    </StyledPriceCol>
                    <OverlayLoadingLayer isLoading={this.isLoading} />
                </StyledAccessoryItemWrapper>
                {formErrors ? (
                    <Alert variant='danger' className='mb-3'>
                        {formErrors}
                    </Alert>
                ) : (
                    ''
                )}
            </React.Fragment>
        )
    }
}

export default withTheme(
    withTranslation()(
        inject('productsStore')(observer(AccessoryItem))
    )
)
